import { render, staticRenderFns } from "./GalleryComponent.vue?vue&type=template&id=e9b7cbae&scoped=true&"
import script from "./GalleryComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryComponent.vue?vue&type=style&index=0&id=e9b7cbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b7cbae",
  null
  
)

export default component.exports